<template lang="html">
  <div id="error-page">

    <section class="container-fluid align-items-center d-flex section">
      <div class="bar">
        <h1 class="mb-3">Error 404. Pagina no encontrada</h1>
        <p>
          <router-link class="trans-250 link-home" to="/"><i class="fas fa-home-lg-alt icon"></i> Ir al Inicio</router-link>
        </p>
      </div>
    </section>

  </div>
</template>

<script>
export default {
}
</script>
